import {Component, OnInit} from '@angular/core';
import { LogService } from '../../shared';
import { CognitoAuthService } from '../../shared';
declare const moment: any;

@Component({
    selector: 'logs',
    templateUrl: './logs.component.html',
    styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit {

    isLogsDataLoading = true;
    isLogsDataError = false;
    maxLogsDataCallRetries = 3;
    logsDataSubscription;

    logs = [ ];

    logPrefix = '';

    constructor(private logService: LogService, private authService: CognitoAuthService) {
    }

    ngOnInit() {
        this.getLogs();
    }

    reloadLogs() {
        this.getLogs();
    }

    getLogs() {

        const self = this;

        self.isLogsDataLoading = true;

        // TODO: Extract the prefix from the input field in the page
        this.authService.getIdToken({
            callback() {},
            callbackWithParam(idToken: any) {
                const customer = self.authService.decodeToken(idToken)['custom:customer'];
                self.logsDataSubscription = self.logService.getLogs(idToken, self.logPrefix, customer).subscribe(function (logs) {
                    self.logs = logs;
                    self.isLogsDataLoading = false;
                    self.isLogsDataError = false;

                    // clean up the fields a tad bit
                    logs.forEach(function(log) {
                        const name = log.Name;
                        log.date = name.substring(name.indexOf('/') + 1, name.lastIndexOf('/'));
                        log.fileName = name.substring(name.lastIndexOf('_') + 1, name.lastIndexOf('-'));
                        log.fileName += '.log';
                    });
                }, function (err) {

                    console.log('Error in getLogs() of dashboard.component');

                    self.logs = [];
                    self.isLogsDataLoading = false;
                    self.isLogsDataError = true;

                    self.logsDataSubscription.unsubscribe();
                    --self.maxLogsDataCallRetries;
                    if (self.maxLogsDataCallRetries > 0) {
                        self.getLogs();
                    }
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// /app/src/app/containers/logs/logs.component.ts